/** @format */

import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import _ from 'lodash';
import { BORDER_GRAY, GREEN, GREY } from '../../constants/style';

interface VegaSelectorListProps {
  options: string[];
  onSelect: (isSelected: boolean, value: string) => void;
  selected: string[];
}

const VegaSelectorList = ({ options, onSelect, selected }: VegaSelectorListProps) => {
  return (
    <>
      <Grid container spacing={2}>
        {options.map((option: any) => {
          return (
            <Grid item xs={12} sm={6} sx={{ my: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  border: BORDER_GRAY,
                  borderRadius: '4px',
                  px: 1,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selected && selected.includes(option)}
                      onChange={(e: any) => onSelect(e.target.checked, option)}
                      sx={{
                        color: GREY.dark,
                        '&.Mui-checked': {
                          color: GREEN.dark,
                        },
                      }}
                    />
                  }
                  label={_.startCase(_.toLower(option))}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default VegaSelectorList;
